import { render, staticRenderFns } from "./TextImage.vue?vue&type=template&id=6a668476&scoped=true&"
import script from "./TextImage.vue?vue&type=script&lang=js&"
export * from "./TextImage.vue?vue&type=script&lang=js&"
import style0 from "./TextImage.vue?vue&type=style&index=0&id=6a668476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a668476",
  null
  
)

export default component.exports